<template>
	<div class="imgText">
		<section class="proImg"><span><img :src="data.Pic" alt="" @click="shouImg()"></span></section>
		<section class="audio">
		   <div class="so_rs">
		       <div class="audio-btn">
		            <i @click="audioState"><img :src="imgUrl2" alt="" v-show="iconshouw==true ? true : false"><img :src="imgUrl1" alt=""  v-show="iconshouw==true?false : true"/></i>
		       </div>
		       <div class="bar" style="position: relative;">
		           <div class="progressbar"  ref="runfatbar" @click="playMusic">
		               <div class="greenbar" ref="runbar">
		                   <span class="yuan" draggable="true"></span>
		               </div>
		           </div>
		           <span style="margin-top:-3px;position: absolute;right: 0;font-size: 10px;color: #999;">{{cTime}}</span>
		           <span style="margin-top:-3px;position: absolute;left:-5px;font-size: 10px;color: #999;">{{dTime}}</span>
		       </div>
		       <div>
		           <audio ref="player" src="https://media.artron.net/trad/mp3/201906/b8e67da1adcd13ea1048bf80fd3262a0.mp3">
		           </audio>
		       </div>
		   </div>
		</section>
		<section class="proDetail">
		    <h2>{{data.Name}}</h2>
		    <div class="proType">
		        <p>{{data.Author}}</p>
		        <p>{{data.WorkType}}</p>
		        <p>{{data.Size}}</p>
		        <p>{{data.CreationDate}}</p>
		        <p>{{data.Quality}}</p>
		        <p>{{data.Memo}}</p>
		    </div>
		</section>
		<div v-show="iSshow" class="markT" @click="iSshow=false">
			<swiper>
				<swiper-slide class="stop">
					<div class="swiper-zoom-container">
					 	<div class="imgbox">
					 		<img :src="data.Pic" alt="">
					 	</div>
					</div>
				</swiper-slide>
			</swiper>
		</div>
	</div>
</template>
<script type="text/javascript">
	import Swiper from 'swiper';
	import 'swiper/dist/css/swiper.min.css';
	import { swiper, swiperSlide } from 'vue-awesome-swiper';
	export default {
		data(){
			return{
				iconshouw:true,
				play: false, // 播放暂停按钮
				imgUrl1:require('../static/imgs/stop.png'),
				imgUrl2:require('../static/imgs/btn_90-90.png'),
				cTime: '00:00', // 已播放时间
				dTime: '00:00', // 总播放时间
				play: false, // 播放暂停按钮
				audioHttp: '', // 音频链接
				barOffleft: '', //点击距离左侧时间
				id:'',
				data:'',
				iSshow:false
			}
		},
		mounted(){
			this.id=this.$route.query.id;
			//音频播放处理
			const music = this.$refs.player  // 音频所在对象
			const musicBar = this.$refs.runbar  // 颜色进度条所在对象
			const musicWidth = this.$refs.runfatbar.offsetWidth // 底部进度条总宽
			// 获得音频加载完成可播放时的处理
			music.addEventListener('canplay', (res) => {
			    const musicTime = music.duration // 获得音频时长
			    //console.log(res)
			    const branch = Math.floor(musicTime / 60) // 计算音频分钟
			    const second = Math.ceil(musicTime % 60) // 计算音频秒
			    if (branch < 10 && second < 10) { // 四种情况判断音频总时间
			        this.dTime = `0${branch}:0${second}`
			    } else if (branch < 10) {
			        this.dTime = `0${branch}:${second}`
			    } else if (second < 10) {
			        this.dTime = `${branch}:0${second}`
			    } else {
			        this.dTime = `${branch}:${second}`
			    }
			})
			// 获得音频正在播放时的处理
			music.addEventListener('timeupdate', () => {
			    const musicTime = music.duration // 获得音频时长
			    const stopTime = music.currentTime // 获得已播放的音频时长
			    musicBar.style.width = `${(stopTime / musicTime) * 100}%` // 计算进度条所在比例宽度
			    const branch = Math.floor(stopTime / 60) // 计算已播放的音频分钟
			    const second = Math.floor(stopTime % 60) // 计算已播放的音频秒
			    if (branch < 10 && second < 10) { // 四种情况判断显示音频以播放时间
			        this.cTime = `0${branch}:0${second}`
			    } else if (branch < 10) {
			        this.cTime = `0${branch}:${second}`
			    } else if (second < 10) {
			        this.cTime = `${branch}:0${second}`
			    } else {
			        this.cTime = `${branch}:${second}`
			    }
			})
			musicBar.addEventListener('touchmove', (event) => {
			     const events = event.targetTouches[0].pageX-this.$refs.runfatbar.offsetLeft // 获得触摸拖动的距离
			     if(events <= musicWidth){
			         musicBar.style.width = `${(events / musicWidth) * 100}%` // 计算进度条所在比例宽度
			     }else{
			         musicBar.style.width = '100%'
			     }
			     music.pause() // 触摸拖动时停止播放
			})
			// 监听颜色进度条是否触摸拖动结束
			musicBar.addEventListener('touchend', () => {
			     const touwidth = (musicBar.offsetWidth / musicWidth) // 计算进度条所在比例
			     //console.log(touwidth)
			     music.currentTime = music.duration * touwidth // 通过所在比例赋值给音频应在的播放时间
			     music.play() // 根据播放时间开始播放
			     this.play = true // 更改播放暂停按钮为播放
			})
			//调取数据
			this.getData()
			//轮播图
			var mySwiper = new Swiper('.swiper-container',{
			 	zoom:true,
			 	observer:true,//修改swiper自己或子元素时，自动初始化swiper
			 	observeParents:true,//修改swiper的父元素时，自动初始化swiper
			 	navigation: {
			 	      nextEl: '.swiper-button-next',
			 	      prevEl: '.swiper-button-prev',
			 	},
			})
		},
		methods:{
			//点击播放暂停按钮时间
			audioState () {
			   this.iconshouw=!this.iconshouw;
			    this.play = !this.play;// 更改播放暂停按钮状态
			    const music = this.$refs.player // 音频所在对象
			    if (this.play) {
			        music.play() // 播放音乐
			    } else {
			        music.pause() // 暂停音乐
			    }
			},
			//点击进度条事件
			playMusic (e) {
			    const music = this.$refs.player // 音频所在对象
			    const barWidth = (e.pageX-this.$refs.runfatbar.offsetLeft)/ this.$refs.runfatbar.offsetWidth // 计算点击位置相对父元素总宽的比例
			    this.$refs.runbar.style.width = `${barWidth * 100}%` // 进度条应所在的比例总宽
			    music.currentTime = music.duration * barWidth // 计算点击时应播放所在的时间
			    music.play() // 播放音频
			    this.play = true // 更改播放暂停按钮为播放
			},
			getData(){
				//console.log(this.$route.query)
				this.$http.get(this.$api+'/exhibit_work_detail_api.html?id='+this.id)
				.then(res => {
				  	this.data=res.data.data;
				  	console.log(this.data)
				})
			},
			shouImg(){
				this.iSshow=true;
			}
		}
	}
</script>
<style scoped>
	.proImg{padding:1rem 1.5rem;}
	.proImg span{display:block;height:13.6rem;display:-webkit-box;overflow: hidden;-webkit-box-orient:horizontal;-webkit-box-pack:center;-webkit-box-align:center;background-color: #eee;width:100%}
	.proImg span img{width:100%;object-fit:contain;}
	.audio{background-color: #f9f9f9;text-align: center;padding-top: 0.55rem;padding-bottom: 0.55rem;}
	.audio audio{background-color: transparent;}
	.proDetail{padding:0 1.05rem;}
	.proDetail h2{color:#333;font-size: .8rem;padding:.75rem 0;}
	.proType{line-height: 1.2rem;font-size: .75rem;color:#666;}
	.markT{position:fixed;width:100%;height:100%;top: 0;bottom:0;left:0;right:0;background:#000}
	.imgbox img{width:100%}
	.swiper-container {
	    width:100%;
	    height:100%;
	    position: absolute;
	}
	.so_rs{
	    width: 100%;
	    height:1.6rem;
	    background: #f9f9f9;
	    position:relative;
	    box-sizing: border-box;
	    display: flex;
	}
	/*自定义进度条*/
	.bar{
	    width: 60%;
	    height:1.4rem;
	    line-height:1.4rem;
	    box-sizing: border-box;
	    padding:.75rem 0;
	}
	/*播放按钮*/
	.audio-btn{
	    width: 32px;
	    left: 1.14rem;
	    margin:0 20px;
	    margin-left: 2.5rem;
	}
	.audio-btn i img{
		width: 100%;
	}
	.icon{
	    display:block;
	    height:1.3rem;
	    width:1.3rem;
	}
	.progressbar{
	    width:100%;
	    height: .1rem;
	    background-color: #999999;
	    border-radius: 10px;
	    position: relative;
	    font-size:0;
	}
	.greenbar {
	    width: 0%;
	    height: .1rem;
	    border-radius: .2rem;
	    position: absolute;
	    top: 0;
	    left: 0;
	    background-color: #e77959;
	}
	.yuan {
	    display: inline-block !important;
	    padding: .15rem;
	    background-color: #e77959;
	    box-sizing: border-box;
	    border-radius: 50%;
	    position: absolute;
	    top: -.09rem;
	    right: -.1rem;
	}
</style>